export default __webpack_public_path__ + "static/ollie-2bbd73d84bf1ef8e24c39d6116cbbed7.jpg";